export default "__VITE_ASSET__$CY0LDha__"